import { MenuItem, Select } from '@material-ui/core';
import React, { FC, useState } from 'react';

import { createDuration, Duration, Periods } from '../common/duration';
import { selectorStyles } from './data-panel';
import { DurationSelector } from './duration-selector';
import { NavigationSelect } from './navigation-select';
import { OutreachSchedulesDataPanel } from './outreach-schedules-data-panel';
import { OutreachSearchResultCounts } from './outreach-search-result-counts';
import { OutreachesDataPanel } from './outreaches-data-panel';

export const Outreaches: FC<{
    view?: 'outreaches' | 'outreach-schedules' | 'outreach-search-result-counts';
}> = ({ view }) => {
    const [duration, setDuration] = useState<Duration>(createDuration({ period: 'todayAndLater', offset: 0 }));
    const [user, setUser] = useState<'me' | 'all'>('me');
    const [outreachType, setOutreachType] = useState<'ready' | 'revival'>('ready');

    const handleChangeUser = (event: React.ChangeEvent<{ value: string }>) => {
        const newValue = event.target.value as 'all' | 'me';
        setUser(newValue);
    };

    const handleChangeOutreachType = (event: React.ChangeEvent<{ value: string }>) => {
        const newValue = event.target.value as 'ready' | 'revival';
        setOutreachType(newValue);
    };

    const outreachPeriods: Periods = {
        days: 3,
        months: 2,
        todayAndLater: true,
        weeks: 2
    };

    const durationSelector =
        view === 'outreaches' ? (
            <DurationSelector selected={duration} onSelect={setDuration} periods={outreachPeriods} />
        ) : null;

    const outreachTypeSelector =
        view === 'outreach-search-result-counts' ? (
            <Select value={outreachType} onChange={handleChangeOutreachType} variant="outlined">
                <MenuItem value="ready">Initial</MenuItem>
                <MenuItem value="revival">Revival</MenuItem>
            </Select>
        ) : null;

    const viewRoutes: Array<[string, string]> = [
        ['Schedules', '/outreach-schedules'],
        ['Outreaches', '/outreaches'],
        ['Search results', '/outreach-search-result-counts']
    ];

    const userSelect = (
        <Select value={user} onChange={handleChangeUser} variant="outlined">
            <MenuItem value="me">Me</MenuItem>
            <MenuItem value="all">All</MenuItem>
        </Select>
    );

    const content =
        view === 'outreaches' ? (
            <OutreachesDataPanel duration={duration} username={user === 'me' ? user : undefined} />
        ) : view === 'outreach-schedules' ? (
            <OutreachSchedulesDataPanel username={user === 'me' ? user : undefined} />
        ) : view === 'outreach-search-result-counts' ? (
            <OutreachSearchResultCounts
                username={user === 'me' ? user : undefined}
                revival={outreachType === 'revival'}
            />
        ) : null;

    return (
        <>
            <div className="selectors">
                <div css={selectorStyles}>
                    {userSelect}
                    {outreachTypeSelector}
                    {durationSelector}
                    <NavigationSelect routes={viewRoutes} />
                </div>
            </div>
            <div className="data-panel">{content}</div>
        </>
    );
};
